import React from "react";
import {
    IconDocumentLinesCircle,
    IconVehicle
} from "../../../../../../components/buttons/IconButtons";
import {CustomTextField} from "../../../../../../components/CustomTextField";
import CustomDateTimePicker from "../../../../../../components/CustomDateTimePicker";
import MaterialsInOut from "./MaterialsInOut";
import MovementDirectionSection from "./MovementDirectionSection";
import DepartureSection from "./DepartureSection";
import {
    MOVEMENT_DIRECTION_DATE_DEFAULTS,
    MOVEMENT_DIRECTION_SECTION_DEFAULTS,
    PLANT_MATERIAL_CONTROL_ITEM_MODEL,
    VEHICLE_INFORMATION_LENGTH,
    buildEntryAndExitFormItem,
    getMovementDirectionOption,
    getMovementDirectionSection
} from "../../../Model/Model";
import CustomUserChip from "../../../../../../components/CustomUserChip";
import {POSITION_MODEL} from "../../../../../../Helpers/PositionModel";
import { PERIOD_TIME_UNIT_ENUM } from "../../../../../../enums/PeriodTimeUnitEnum";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const PlantMaterialControlRequestSections = ({
    t,
    handleChange,
    materialRequest,
    setMaterialRequest,
    emptyFields,
    emptyFieldsItems,
    setEmptyFieldsItems
}) => {

    const selectedDirectionOption = getMovementDirectionOption(materialRequest?.movementDirection);
    const selectedDirectionSection = getMovementDirectionSection(materialRequest?.movementDirection);
    const SelectedDirectionIcon = selectedDirectionOption?.Icon;

    /**
     * Sets the movement direction of the form.
     *
     * When the direction changes, every field enabled by the previous direction
     * is restored to its default value, so the information captured for it is
     * neither displayed nor submitted.
     *
     * @param {number} movementDirection - Selected movement direction.
     *
     * @returns {void}
     */
    const handleSelectMovementDirection = (movementDirection) => {
        if (materialRequest?.movementDirection === movementDirection)
            return;

        setEmptyFieldsItems(false);
        setMaterialRequest((prev) => ({
            ...prev,
            ...MOVEMENT_DIRECTION_DATE_DEFAULTS,
            ...MOVEMENT_DIRECTION_SECTION_DEFAULTS,
            items: [buildEntryAndExitFormItem(PLANT_MATERIAL_CONTROL_ITEM_MODEL)],
            movementDirection,
        }));
    };

    return (
        <>
            <MovementDirectionSection
                t={t}
                idPrefix={"pmc"}
                materialRequest={materialRequest}
                onSelectDirection={handleSelectMovementDirection}
                emptyFields={emptyFields}
            >
                { selectedDirectionSection &&
                <DepartureSection
                    t={t}
                    section={selectedDirectionSection}
                    materialRequest={materialRequest}
                    handleChange={handleChange}
                    emptyFields={emptyFields}
                />
                }
            </MovementDirectionSection>

            <div className='col-12 py-3 mt-3 border-radius-8px background-secondary-50 border-dashed-secondary-150'>
                <CustomUserChip
                    className='m-0 p-0 chip-secondary-150-100 justify-content-start d-flex w-100'
                    name={t('any_field_you_leave_blank_will_be_completed_by_the_guard_at_the_gate')}
                    Icon={IconDocumentLinesCircle}
                    showAvatar={true}
                    classNameIcon={'icon-color-secondary-700'}
                    variant='large'
                    iconPosition={POSITION_MODEL.LEFT}
                />

                <div className="border-full-shades-300 background-general-00 border-radius-8px my-3">
                    <div className={"d-flex p-2"}>
                        <div className={"mr-2"}><IconVehicle/></div>
                        <p className={"fs-14px ibl-font-w-600"}>{t("transport")}</p>
                    </div>
                    <div className={"border-bottom-shades-300 mb-3"}/>

                    <div className={"py-3"}>
                        <div className={"col-12"}>
                            <CustomTextField
                                id={'txt_pmc_carrier_company'}
                                length={128}
                                name={'carrierCompany'}
                                value={materialRequest?.carrierCompany}
                                trans={'carrier_company'}
                                type={'text'}
                                onChange={handleChange}
                                emptyFields={false}
                                required={false}
                                placeholder={t('enter_carrier_company_name')}
                            />
                        </div>

                        <div className={"col-12"}>
                            <CustomTextField
                                id={'txt_pmc_vehicle_information'}
                                length={VEHICLE_INFORMATION_LENGTH}
                                name={'vehicleInformation'}
                                trans={'vehicle_information'}
                                value={materialRequest.vehicleInformation}
                                type={'text'}
                                disabled={false}
                                onChange={handleChange}
                                multiline={true}
                                placeholder={t('add_optional_vehicle_details_such_as_plate_number_color_model_or_any_relevant_notes')}
                                marginBottom={false}
                            />
                        </div>
                    </div>
                </div>

                { selectedDirectionOption &&
                <div className="border-full-shades-300 background-general-00 border-radius-8px mb-3">
                    <div className={"d-flex align-items-center p-2"}>
                        <div className={`mr-2 ${selectedDirectionOption.iconBackground} p-2 border-radius-8px d-flex align-items-center`}>
                            <SelectedDirectionIcon className={selectedDirectionOption.iconColor}/>
                        </div>
                        <p className={"fs-14px ibl-font-w-600"}>{t(selectedDirectionOption.trans)}</p>
                    </div>
                    <div className={"border-bottom-shades-300 mb-3"}/>

                    <div className={"py-3"}>
                        <div className={"col-12"}>
                            <CustomDateTimePicker
                                id={`dp_pmc_${selectedDirectionOption.dateTrans}`}
                                name={selectedDirectionOption.dateName}
                                onChange={(e) => {
                                    handleChange({target: {value: e, name: selectedDirectionOption.dateName}});
                                }}
                                trans={selectedDirectionOption.dateTrans}
                                value={materialRequest?.[selectedDirectionOption.dateName]}
                                required={false}
                                openTo={PERIOD_TIME_UNIT_ENUM.DAYS.key}
                                disablePast={true}
                                emptyFields={false}
                            />
                        </div>

                        <div className={"col-12"}>
                            <MaterialsInOut
                                emptyFields={emptyFields}
                                materialRequest={materialRequest}
                                setMaterialRequest={setMaterialRequest}
                                emptyFieldsItems={emptyFieldsItems}
                                setEmptyFieldsItems={setEmptyFieldsItems}
                                required={false}
                            />
                        </div>
                    </div>
                </div>
                }
            </div>
        </>

    );
};

export default PlantMaterialControlRequestSections;
